var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRectangleButtonRight = function SvgRectangleButtonRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.643,
    height: 107.957,
    viewBox: "0 0 87.643 107.957"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    transform: "translate(-998.326 -581)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    d: "M43.657,107.856Q21.854,80.939,0,54.077C7.789,44.223,15.868,34.519,23.748,24.7,30.473,16.493,37.122,8.175,43.857,0,58.534,17.892,73.02,35.966,87.643,53.913c-2.018,3.076-4.743,5.836-6.971,8.83C68.349,77.787,56.153,92.95,43.8,107.957Z",
    transform: "translate(998.326 581)",
    fill: "#1c5868"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow_2_",
    d: "M-937,921.086l.808.808,6.119-6.119-6.119-6.119-.808.808,5.311,5.311L-937,921.086Z",
    transform: "translate(1975.683 -280.796)",
    fill: "#ffebc3",
    fillRule: "evenodd"
  }))));
};

export { SvgRectangleButtonRight as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4Ny42NDMiIGhlaWdodD0iMTA3Ljk1NyIgdmlld0JveD0iMCAwIDg3LjY0MyAxMDcuOTU3Ij4KICA8ZyBpZD0iR3JvdXBfOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTk5OC4zMjYgLTU4MSkiPgogICAgPHBhdGggaWQ9IlVuaW9uXzEiIGQ9Ik00My42NTcsMTA3Ljg1NlEyMS44NTQsODAuOTM5LDAsNTQuMDc3QzcuNzg5LDQ0LjIyMywxNS44NjgsMzQuNTE5LDIzLjc0OCwyNC43LDMwLjQ3MywxNi40OTMsMzcuMTIyLDguMTc1LDQzLjg1NywwLDU4LjUzNCwxNy44OTIsNzMuMDIsMzUuOTY2LDg3LjY0Myw1My45MTNjLTIuMDE4LDMuMDc2LTQuNzQzLDUuODM2LTYuOTcxLDguODNDNjguMzQ5LDc3Ljc4Nyw1Ni4xNTMsOTIuOTUsNDMuOCwxMDcuOTU3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTk4LjMyNiA1ODEpIiBmaWxsPSIjMWM1ODY4Ii8+CiAgICA8cGF0aCBpZD0iYXJyb3dfMl8iIGQ9Ik0tOTM3LDkyMS4wODZsLjgwOC44MDgsNi4xMTktNi4xMTktNi4xMTktNi4xMTktLjgwOC44MDgsNS4zMTEsNS4zMTFMLTkzNyw5MjEuMDg2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTk3NS42ODMgLTI4MC43OTYpIiBmaWxsPSIjZmZlYmMzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz4KICA8L2c+Cjwvc3ZnPgo=";